import { Controller } from "stimulus";
import { isStickyNavigation, setStickyNavigation } from "../sticky_navigation";

export default class extends Controller {
  connect() {
    this.element.checked = isStickyNavigation();
  }

  toggle() {
    setStickyNavigation(this.element.checked);
  }
}
